/**
 * Legal policies — policy document boundary contract schema.
 *
 * Owned here, not beside the route: `apps/api/src/routes/system/policies.routes.ts` imports this to
 * register the route, and `packages/consent-ui`'s `usePolicyDocument` parses the response with the
 * same object. See packages/api-types/README.md.
 *
 * Policy types and current versions live in `@resida/shared` (legal-policies.ts), not here:
 * `@resida/shared` already depends on this package, so the reverse import would be a cycle.
 *
 * Covers:
 *   GET /api/policies/:policyType
 */
import { z } from 'zod';
/** A published policy document: its type, current version and markdown content. */
export const PolicyResponseSchema = z.object({
    policyType: z.string(),
    version: z.string(),
    content: z.string(),
});
//# sourceMappingURL=legal-policies.js.map